
import { useEffect, useState, useRef } from "react";
import { MarkdownRenderer } from "../common_components/text_display_utilities";
//import { useRef } from "react-router-dom";

function InterviewChatUI({ messages}) {
  /** used to scroll to view every time a new message is added */
  const messagesContainerRef = useRef(null);
  
  // Scroll to bottom whenever messages update
  useEffect(() => {
   // console.log("initilizing chat messages scroll to view")
    
    if (messagesContainerRef.current) {
      //messagesContainerRef.current?.scrollIntoView({ behavior: "smooth" });
      setTimeout(() => {
        messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
      }, 10); // Forces reflow
      
    }
  }, [messages]);
    
  return (
    <div className="flex flex-col  ">
      {/*  overflow-y-visible m-4 
    scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 hover:scrollbar-thumb-gray-500 */}
      { false &&
        <div className="text-2xl p-2 ">Discussion</div>
      }  
      
      {/* Messages List */}
      {messages &&
      <div  ref ={messagesContainerRef} 
      className=" flex flex-col h-[50vh] border rounded-lg bg-gray-100 overflow-y-auto space-y-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
        {/* h-1/2 didn't work, so i used h-[50vh] */}
        { messages.map((msg, index) => (
          <div key={index} className={`p-2 px-4 rounded-lg max-w-[85%] 
          ${msg.type === "interviewer" ? "bg-white text-gray-800 self-end" 
          : "bg-gray-300 text-black self-start"}`}>
            <span className="font-semibold">{msg.type}: </span>
            <MarkdownRenderer content={msg.text} />
          </div>
        ))}
      </div>
      }
      
    </div>
  );
}

/**
 * component to add user's text message to char
 */
function AddMessageToChatUI({addChat}){
  const [inputText, setInputText] = useState("");
  const handleSubmit = () => {
    if (inputText && inputText.trim()) {
      addChat(inputText);
      setInputText("");
    }
  };

  return (
    <div className="  text-gray-800 w-1/3 m-4 flex flex-col ">
    <textarea
      className="w-full border p-2 rounded resize-none h-12"
      value={inputText}
      onChange={(e) => setInputText(e.target.value)}
      placeholder="Type your message..."
    />
    <button
      className="mt-2 bg-teal-600 text-white py-2 rounded hover:bg-teal-700"
      onClick={handleSubmit}
    >
      Send
    </button>
  </div>
  );
}

/**
 * component to add user's text message to char
 * using inputText you can update input field's value from parent
 * - it has send button at bottom
 */
function AddMessageToChatUIWithInputControl({inputText, setInputText, submit}){
  //const [inputText, setInputText] = useState("");
  const handleSubmit = () => {
    if (inputText && inputText.trim()) {
      submit(inputText);
      setInputText("");
    }
  };

  return (
    <div className=" w-full text-gray-800 mt-4  m-4 flex flex-col
     justify-center ">
    <textarea
      className="w-full border p-2 rounded  placeholder:text-sm"
      value={inputText}
      rows={4}
      onChange={(e) => setInputText(e.target.value)}
      placeholder="Speak or Type your message..."
    />
    <button
      className="mt-1  bg-teal-600 text-white py-4 rounded-xl
       hover:bg-teal-700 text-xl"
      onClick={handleSubmit}
    >
      Send
    </button>
  </div>
  );
}

/**
 * component to add user's text message to char
 * using inputText you can update input field's value from parent
 * - it has send button at right side
 * @param rows number of visible rows i.e.height of text area, default is 2
 * @param maxChars maximum number of characters that can be entered in text area
 *  default is 2000
 * @param showCounterAfterChars show character counter after these many chars
 * so that users get the idea that there is a character limit
 * default is 1500 , e.g 1501/2000
 */
function AddMessageToChatUISideSend({inputText, setInputText,  
  submit, rows=2, maxChars=2000, showCounterAfterChars=1500}){
  //const [inputText, setInputText] = useState("");
  const handleSubmit = () => {
    if (inputText && inputText.trim()) {
      submit(inputText);
      setInputText("");
    }
  };

  return (
    <div className=" w-full text-gray-800 mt-4  m-4 flex flex-row
     justify-center items-center ">
    <div className="w-full text-center"> 
    <span className="text-sm text-gray-500 text-center">
            Even if transcription is 
            <span className="font-mono font-bold italic"> incorrect, </span>
             AI Interviewer will understand it.
    </span> <br />  
    <textarea
      className="w-full border p-2 rounded 
      placeholder:text-gray-600 placeholder:text-sm"
      value={inputText}
      rows={rows}
      onChange={(e) => 
       { 
        setInputText(e.target.value);
        /* below text won't work because inputText is being set from parent component
        if (e && e.target && e.target.value &&
          e.target.value.length <= maxChars) {
            setInputText(e.target.value);
        }*/
      }
     }
      placeholder="Speak or Type your message
      --------
      DO NOT write any code or method signatures here. 
      Add them in User Area.
      --------
      "
    /> 
     {inputText.length > showCounterAfterChars && (
        <div className="text-sm text-gray-500 text-right mr-4">
          {inputText.length} / {maxChars} characters
        </div>)}
    </div>    

    &nbsp; &nbsp; 

    <button
      className="mt-1  bg-teal-600 text-white py-4 rounded-xl
       hover:bg-teal-700 px-4"
      onClick={handleSubmit}
    >
      Send
    </button>
  </div>
  );
}

export {InterviewChatUI, AddMessageToChatUI, AddMessageToChatUIWithInputControl, AddMessageToChatUISideSend};

